
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as change_45emailUNZQ0QkeBsMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/change-email.vue?macro=true";
import { default as change_45password56KUlXwAQPMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/change-password.vue?macro=true";
import { default as _91key_93utPwymo6hrMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/confirm-email/[key].vue?macro=true";
import { default as loginedt2w1ulZHMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/login.vue?macro=true";
import { default as logout5W2HrpNPO7Meta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/logout.vue?macro=true";
import { default as cards2To8krhG5dMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/cards.vue?macro=true";
import { default as editfT2z4eHPgwMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/edit.vue?macro=true";
import { default as indexbDIw8217mJMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/index.vue?macro=true";
import { default as _91key_93on6sOkKQOBMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/reset-password/[key].vue?macro=true";
import { default as signupHO3CK1KZ9BMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/signup.vue?macro=true";
import { default as _91token_93hW8J5inXZRMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/bnpl_invite/[locationNumber]/[token].vue?macro=true";
import { default as indexp9dmQ5rcscMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/index.vue?macro=true";
import { default as searchbWCT69okp0Meta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/office/search.vue?macro=true";
import { default as historyAFsFHMV8kwMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/history.vue?macro=true";
import { default as itemCTL47us7CcMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/item.vue?macro=true";
import { default as locationVAt8Xdv0wiMeta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/location.vue?macro=true";
import { default as receiptPfqKKRJjn4Meta } from "/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/receipt.vue?macro=true";
export default [
  {
    name: "accounts-change-email",
    path: "/accounts/change-email",
    meta: change_45emailUNZQ0QkeBsMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/change-email.vue")
  },
  {
    name: "accounts-change-password",
    path: "/accounts/change-password",
    meta: change_45password56KUlXwAQPMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/change-password.vue")
  },
  {
    name: "accounts-confirm-email-key",
    path: "/accounts/confirm-email/:key()",
    meta: _91key_93utPwymo6hrMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/confirm-email/[key].vue")
  },
  {
    name: "accounts-login",
    path: "/accounts/login",
    meta: loginedt2w1ulZHMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/login.vue")
  },
  {
    name: "accounts-logout",
    path: "/accounts/logout",
    meta: logout5W2HrpNPO7Meta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/logout.vue")
  },
  {
    name: "accounts-profile-cards",
    path: "/accounts/profile/cards",
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/cards.vue")
  },
  {
    name: "accounts-profile-edit",
    path: "/accounts/profile/edit",
    meta: editfT2z4eHPgwMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/edit.vue")
  },
  {
    name: "accounts-profile",
    path: "/accounts/profile",
    meta: indexbDIw8217mJMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/profile/index.vue")
  },
  {
    name: "accounts-reset-password-key",
    path: "/accounts/reset-password/:key()",
    meta: _91key_93on6sOkKQOBMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/reset-password/[key].vue")
  },
  {
    name: "accounts-signup",
    path: "/accounts/signup",
    meta: signupHO3CK1KZ9BMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/accounts/signup.vue")
  },
  {
    name: "bnpl_invite-locationNumber-token",
    path: "/bnpl_invite/:locationNumber()/:token()",
    meta: _91token_93hW8J5inXZRMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/bnpl_invite/[locationNumber]/[token].vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexp9dmQ5rcscMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/index.vue")
  },
  {
    name: "office-search",
    path: "/office/search",
    meta: searchbWCT69okp0Meta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/office/search.vue")
  },
  {
    name: "purchase-history",
    path: "/purchase/history",
    meta: historyAFsFHMV8kwMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/history.vue")
  },
  {
    name: "purchase-item",
    path: "/purchase/item",
    meta: itemCTL47us7CcMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/item.vue")
  },
  {
    name: "purchase-location",
    path: "/purchase/location",
    meta: locationVAt8Xdv0wiMeta || {},
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/location.vue")
  },
  {
    name: "purchase-receipt",
    path: "/purchase/receipt",
    component: () => import("/runner/_work/l-box-user-front/l-box-user-front/pages/purchase/receipt.vue")
  }
]